<mat-card class="individual-list-container">
  <div class="row">
    <div class="col-md-6">
      <mat-card-title>Individuals</mat-card-title>
    </div>
    <div class="col-md-6 text-end">
      <form [formGroup]="individualFilterForm">
        <mat-form-field appearance="outline" class="me-2">
          <mat-label>Search</mat-label>
          <input type="text" formControlName="search" matInput />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Individual type</mat-label>
          <mat-select [formControl]="individualType">
            <mat-option [value]="allIndividualTypes">All</mat-option>
            <mat-option
              *ngFor="let type of individualTypes"
              [value]="type.code"
            >
              {{ type.type }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </form>
    </div>
  </div>

  <mat-paginator
    [length]="totalNumberOfIndividuals"
    [pageIndex]="page - 1"
    [pageSize]="limit"
    [pageSizeOptions]="[10, 15, 20]"
    showFirstLastButtons
    (page)="onPageChange($event)"
    aria-label="Select page of individuals"
  >
  </mat-paginator>

  <div class="py-2">
    <mat-divider></mat-divider>
  </div>

  <table
    mat-table
    [dataSource]="individualsDataSource"
    matSort
    (matSortChange)="sortIndividuals($event)"
    class="individual-list"
  >
    <ng-container matColumnDef="title">
      <th mat-header-cell *matHeaderCellDef>Title</th>
      <td mat-cell *matCellDef="let individual">{{ individual.title }}</td>
    </ng-container>
    <ng-container matColumnDef="name">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        sortActionDescription="Sort by Name"
        start="desc"
      >
        Name
      </th>
      <td mat-cell *matCellDef="let individual">
        {{ individual.first_name + " " + individual.last_name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef>Type</th>
      <td mat-cell *matCellDef="let individual">
        {{ getIndividualType(individual) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="contact">
      <th mat-header-cell *matHeaderCellDef>Contact</th>
      <td mat-cell *matCellDef="let individual">
        {{ individual.phone_number }}
      </td>
    </ng-container>

    <ng-container matColumnDef="sage">
      <th mat-header-cell *matHeaderCellDef>Sage</th>
      <td mat-cell *matCellDef="let individual">
        <span *ngIf="isOnSage(individual)" class="text-success">On Sage</span>
        <span *ngIf="!isOnSage(individual)" class="text-muted">Not on Sage</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="created_at">
      <th mat-header-cell *matHeaderCellDef>Created</th>
      <td mat-cell *matCellDef="let individual">
        {{ getCreationTime(individual) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="updated_at">
      <th mat-header-cell *matHeaderCellDef>Updated</th>
      <td mat-cell *matCellDef="let individual">
        {{ formatTime(individual.updated_at) }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      (click)="viewIndividual(row.id)"
      *matRowDef="let row; columns: displayedColumns"
    ></tr>
  </table>
</mat-card>
